// @ts-check
import React from 'react'
import { ConfirmModalComponent } from '~/legacy/components'

// A modal to edit a project
export const DeleteSpaceFieldModal = ({
  fieldName,
  surveyName,
  deleteSpaceField,
  isBuildingField,
  open,
  onClose,
  textOverride = undefined,
}) => {
  const text = `Are you sure you want to delete the ${fieldName} field?
  This will remove the field from all ${
    isBuildingField ? 'buildings' : 'spaces'
  } in the ${surveyName} survey. This action can't be undone.`

  return (
    <ConfirmModalComponent
      ModalComponentProps={{
        open: !!open,
        onClose,
      }}
      onClose={onClose}
      onConfirm={async () => {
        try {
          onClose()
          await deleteSpaceField()
        } catch {
          // supress
        }
      }}
      title="Delete Field"
      confirmButtonLabel="Delete"
      text={textOverride || text}
    />
  )
}

// Get the delete field modal and its open/closed state
export const useDeleteSpaceFieldModal = ({
  fieldName,
  surveyName,
  deleteSpaceField,
  isBuildingField,
  onClose,
}) => {
  const [open, setOpen] = React.useState(false)

  const DeleteSpaceFieldModalComponent = (
    <DeleteSpaceFieldModal
      fieldName={fieldName}
      surveyName={surveyName}
      deleteSpaceField={deleteSpaceField}
      isBuildingField={isBuildingField}
      open={open}
      onClose={onClose}
    />
  )

  return {
    open,
    setOpen,
    DeleteSpaceFieldModalComponent,
  }
}
